import { EHarvestingView } from 'components/Experiment/Harvesting/constants';
import HarvestingTabs from 'components/Experiment/Harvesting/tabs/harvestingTabs';
import { getHarvestingViewTitle } from 'components/Experiment/Harvesting/utils';
import BaseSidePanel from 'components/sidePanel/baseSidePanel';
import { ITabItem } from 'components/tab/hooks';
import React, { useEffect, useState } from 'react';
import { useHarvestingConentView } from 'redux/hooks/synchrotron';

const tabItems_: ITabItem[] = [
  {
    title: 'Harvesting',
    content: <HarvestingTabs />,
  },
];
const Harvesting = () => {
  const [contentTitle, setContentTitle] = useState('');
  const view = useHarvestingConentView();

  useEffect(() => {
    setContentTitle(getHarvestingViewTitle(view));
  }, [view]);

  return (
    <BaseSidePanel
      id='sidepanel-exp-harvesting'
      tabItems={tabItems_}
      headerTitle={contentTitle}
      headerIconProps={view === EHarvestingView.HARVESTING && { name: 'Harvesting' }}
    />
  );
};
export default Harvesting;
